import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import OrcamentoDetailsModal from '../OrcamentoDetailsModal';
import ExcluirOrcamento from '../ExcluirOrcamento';
import OrcamentoForm from '../OrcamentoForm/index cop';
import PrintButton from '../PrintButton';
import DownloadButton from '../DownloadButton';
import api3001 from '../../services/api3001';
import Swal from "sweetalert2";
import {SelectStatus, SelectPayment} from '../SelectStatus';


// Função para formatar a data
const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Mês começa do 0
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

// Função para formatar o valor como moeda (R$)
const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};


const Title = styled.h1`
  font-size: 28px;
  margin: ${({$filtrar}) => ( $filtrar ? "5px" : "20px")};
  padding:0;
  font-family: 'Arial', sans-serif;
  color: #333;
  text-align: center;
  transition: margin 0.2s ease;

  @media (max-width: 768px) {
    font-size: 24px;
  }

  @media (max-width: 480px) {
    font-size: 20px;
  }
`;

const OrcamentoTableWrapper = styled.div`
  overflow-x: auto;
  margin-top: 10px;
  font-size: 12px;

  @media (max-width: 768px) {
    overflow-x: hidden;
  }
`;

const OrcamentoTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 12px;

  @media (max-width: 768px) {
    display: none;
  }
`;

const TableHead = styled.thead`
  background-color: #151e3d;
  color: white;
  text-align: left;
`;

const TableHeadCell = styled.th`
  padding: 6px;
  font-size: 11px;
`;

const TableRow = styled.tr`
  border-bottom: 1px solid #d3d3d3;
`;

const TableCell = styled.td`
  padding: 4px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Button = styled.button`
  margin: 2px;
  padding: ${({$smal}) => ($smal ? "3px 6px" : "6px 12px")};
  font-size: ${({$smal}) => ($smal ? "11px" : "14px")};
  cursor: pointer;
  border: 1px solid #007bff;
  border-radius: 6px;
  color: #007bff;
  background-color: transparent;
  white-space: nowrap;
  transition: background-color 0.3s ease, transform 0.2s ease;

  &:hover {
    background-color: #007bff;
    color: white;
  }

  &:active {
    transform: scale(0.98);
    background-color: #0056b3;
  }
`;

const Select = styled.select`
  padding: 0.4rem;
  margin: 2px;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-size: 0.8rem;
`;


const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, auto);
  gap: 3px;
`;


const ViewMoreButton = styled(Button)`
  border: 1px solid #007bff;
  color: #007bff;

  &:hover {
    background-color: #007bff;
    color: white;
  }
`;

const EditButton = styled(Button)`
  border: 1px solid #007bff;
  color: #007bff;

  &:hover {
    background-color: #007bff;
    color: white;
  }

  &:active {
    background-color: #0056b3;
  }
`;

const CopyButton = styled(Button)`
  border: 1px solid #007bff;
  color: #007bff;

  &:hover {
    background-color: #007bff;
    color: white;
  }

  &:active {
    background-color: #0056b3;
  }
`;

const ModalWrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Fundo semi-transparente */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 7; 
`;

const ModalContainer = styled.div`
  background-color: #fff;
  width: 80%;
  height: 85%;
  padding: 2rem;
  border-radius: 8px;
  position: relative; 
  max-height: 90vh; 
  overflow-y: auto; 
`;

const CloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: transparent;
  border: none;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  transition: color 0.3s ease;

  &:hover {
    color: #ff0000;
  }
`;



// Estilos para exibir orçamentos como "cartões" em dispositivos móveis
const CardWrapper = styled.div`
  display: none;

  @media (max-width: 768px) {
    display: block;
    margin-top: 20px;
  }
`;

const OrcamentoCard = styled.div`
  background-color: #f8f9fa;
  padding: 20px;
  margin-bottom: 15px;
  border-radius: 8px;
  border: 1px solid #ddd;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const OrcamentoCardItem = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;

  & > span {
    font-weight: bold;
    color: #333;
  }
`;

const OrcamentoCardValue = styled.div`
  background-color: #e9ecef;
  padding: 5px 10px;
  border-radius: 4px;
  color: #495057;
  font-size: 14px;
`;

const CenteredContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 5px;
  align-items: center;
  height: 100%;
`;

const FiltrosWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: 10px;
  justify-content: center;
  align-items: center;
  margin-bottom: 5px;
`;


const OrcamentoList = () => {
  const [orcamentos, setOrcamentos] = useState([]);
  const [error, setError] = useState(null);
  const [showOrcamentoDetails, setShowOrcamentoDetails] = useState(null);
  const [orcamentoEditado, setOrcamentoEditado] = useState(null);
  const [orcamentoCopiado, setOrcamentoCopiado] = useState(null);
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [filtrar, setFiltrar] = useState(false);

  const [filtros, setFiltros] = useState({
    nome: '',
    origem: '',
    destino: '',
    statusViagem: '',
    statusPagamento: ''
  });

  const [filtrosAplicados, setFiltrosAplicados] = useState({
    nome: '',
    origem: '',
    destino: '',
    statusViagem: '',
    statusPagamento: ''
  });

  const token = localStorage.getItem('token');

  const fetchOrcamentos = () => {

    api3001.get('/api/orcamento', {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(response => {
        const data = response.data;
        if (Array.isArray(data)) {
          setOrcamentos(data);
        } else {
          setError('Erro na autenticação.');
        }
      })
      .catch(() => {
        setError('Erro no banco de dados.');
      });
  };

  useEffect(() => {
    fetchOrcamentos();
  }, []);

  const handleViewMoreClick = (orcamento) => {
    setShowOrcamentoDetails(orcamento);
  };

  const handleDeleteSuccess = (id) => {
    setOrcamentos((prev) => prev.filter((o) => o.id !== id));
  };

  const handleEdit = (id) => {
    setOrcamentoEditado(id);
    fetchOrcamentos()
  };

  const handleCopy = (id) => {
  setOrcamentoCopiado(id);
};

  const aplicarFiltros = () => {
    setFiltrosAplicados(filtros);
  };

  const limparFiltros = () => {
    const reset = {
      nome: '',
      origem: '',
      destino: '',
      statusViagem: '',
      statusPagamento: ''
    };

    setFiltros(reset);
    setFiltrosAplicados(reset);
  };

  const listaFiltrada = orcamentos.filter((orcamento) => {

  const f = filtrosAplicados;

  return (
      (!f.nome || orcamento.cliente_nome?.toLowerCase().includes(f.nome.toLowerCase())) &&
      (!f.origem || orcamento.origem?.toLowerCase().includes(f.origem.toLowerCase())) &&
      (!f.destino || orcamento.destino?.toLowerCase().includes(f.destino.toLowerCase())) &&
      (!f.statusViagem || orcamento.status_viagem === f.statusViagem) &&
      (!f.statusPagamento || orcamento.status_pagamento === f.statusPagamento)
    );
  });

  return (
    <div>
      <Title $filtrar={filtrar}>Viagens</Title>

      <CenteredContainer>
        <Button onClick={() => setShowCreateForm(true)}>
          Criar Viagem
        </Button>
        <Button onClick={() => setFiltrar(!filtrar)}>
          Filtros {filtrar ? "▼" : "▲"}
        </Button>
      </CenteredContainer>

      {filtrar && (<FiltrosWrapper $filtrar={filtrar}>

        <Select
          as="input"
          placeholder="Nome"
          value={filtros.nome}
          onChange={(e) => setFiltros({ ...filtros, nome: e.target.value })}
        />

        <Select
          as="input"
          placeholder="Origem"
          value={filtros.origem}
          onChange={(e) => setFiltros({ ...filtros, origem: e.target.value })}
        />

        <Select
          as="input"
          placeholder="Destino"
          value={filtros.destino}
          onChange={(e) => setFiltros({ ...filtros, destino: e.target.value })}
        />

        <Select
          value={filtros.statusViagem}
          onChange={(e) => setFiltros({ ...filtros, statusViagem: e.target.value })}
        >
          <option value="">Status Viagem</option>
          <option value="orcamento">Orçamento</option>
          <option value="prereservado">Pré-Reservado</option>
          <option value="reservado">Reservado</option>
          <option value="terceiro">Terceiro</option>
          <option value="cancelado">Cancelado</option>
          <option value="executado">Executado</option>
        </Select>

        <Select
          value={filtros.statusPagamento}
          onChange={(e) => setFiltros({ ...filtros, statusPagamento: e.target.value })}
        >
          <option value="">Status Pagamento</option>
          <option value="pago">Pago</option>
          <option value="pendente">Pendente</option>
        </Select>

        
        <Button onClick={aplicarFiltros}>Aplicar Filtros</Button>
        <Button onClick={limparFiltros}>Limpar</Button>
  
        

      </FiltrosWrapper>)}

      {error && <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>}

      

      {/* Tabela Desktop */}
      <OrcamentoTableWrapper>
        <OrcamentoTable>
          <TableHead>
            <tr>
              <TableHeadCell style={{width:"10px"}}>id</TableHeadCell>
              <TableHeadCell style={{width:"100px"}}>Cliente</TableHeadCell>
              <TableHeadCell style={{width:"100px"}}>Origem</TableHeadCell>
              <TableHeadCell style={{width:"100px"}}>Destino</TableHeadCell>
              <TableHeadCell style={{width:"60px"}}>Início</TableHeadCell>
              <TableHeadCell style={{width:"60px"}}>Fim</TableHeadCell>
              <TableHeadCell style={{width:"60px"}}>Valor</TableHeadCell>
              <TableHeadCell style={{width:"75px"}}>Pagamento</TableHeadCell>
              <TableHeadCell style={{width:"110px"}}>Status</TableHeadCell>
              <TableHeadCell style={{width:"260px"}}></TableHeadCell>
            </tr>
          </TableHead>
          <tbody>
            {listaFiltrada.map((orcamento) => (
              <TableRow key={orcamento.id}>
                <TableCell>{orcamento.id}</TableCell>
                <TableCell>{orcamento.cliente_nome}</TableCell>
                <TableCell>{orcamento.origem}</TableCell>
                <TableCell>{orcamento.destino}</TableCell>
                <TableCell>{formatDate(orcamento.data_inicio)}</TableCell>
                <TableCell>{formatDate(orcamento.data_fim)}</TableCell>
                <TableCell>{formatCurrency(orcamento.valor_orcado)}</TableCell>
                <TableCell>
                  <SelectPayment
                    $load={fetchOrcamentos}
                    $orcamento_id={orcamento.id}
                    $status_pagamento={orcamento.status_pagamento} 
                  />
                </TableCell>
                <TableCell>
                  <SelectStatus 
                    $load={fetchOrcamentos}
                    $orcamento_id={orcamento.id}
                    $status_viagem={orcamento.status_viagem}
                    $data_inicio={orcamento.data_inicio}
                    $data_fim={orcamento.data_fim}
                  />
                </TableCell>
                <TableCell>
                  <ButtonContainer>
                    <ViewMoreButton $smal={true} onClick={() => handleViewMoreClick(orcamento)}>
                      Ver Mais
                    </ViewMoreButton>
                    <EditButton $smal={true} onClick={() => handleEdit(orcamento.id)}>
                      Editar
                    </EditButton>
                    <CopyButton $smal={true} onClick={() => handleCopy(orcamento.id)}>
                      Copiar
                    </CopyButton>
                    <PrintButton data={{ ...orcamento }} />
                    <DownloadButton data={{ ...orcamento }} />
                    <ExcluirOrcamento
                      orcamentoId={orcamento.id}
                      onDeleteSuccess={handleDeleteSuccess}
                    />

                  </ButtonContainer>
                </TableCell>
              </TableRow>
            ))}
          </tbody>
        </OrcamentoTable>
      </OrcamentoTableWrapper>

      {/* Cartões para telas pequenas */}
      <CardWrapper>
        {listaFiltrada.map((orcamento) => (
          <OrcamentoCard key={orcamento.id}>
            <div style={{ display: 'flex', justifyContent: 'end', gap: '6px', margin: "10px" }}>
              <ExcluirOrcamento
                orcamentoId={orcamento.id}
                onDeleteSuccess={handleDeleteSuccess}
              />
            </div>
            <OrcamentoCardItem>
              <span>Cliente:</span> <OrcamentoCardValue>{orcamento.cliente_nome}</OrcamentoCardValue>
            </OrcamentoCardItem>
            <OrcamentoCardItem>
              <span>Origem:</span> <OrcamentoCardValue>{orcamento.origem}</OrcamentoCardValue>
            </OrcamentoCardItem>
            <OrcamentoCardItem>
              <span>Destino:</span> <OrcamentoCardValue>{orcamento.destino}</OrcamentoCardValue>
            </OrcamentoCardItem>
            <OrcamentoCardItem>
              <span>Data Início:</span> <OrcamentoCardValue>{formatDate(orcamento.data_inicio)}</OrcamentoCardValue>
            </OrcamentoCardItem>
            <OrcamentoCardItem>
              <span>Data Criação:</span> <OrcamentoCardValue>{formatDate(orcamento.criado_em)}</OrcamentoCardValue>
            </OrcamentoCardItem>
            <OrcamentoCardItem>
              <span>Valor Total:</span> <OrcamentoCardValue>{formatCurrency(orcamento.valor_orcado)}</OrcamentoCardValue>
            </OrcamentoCardItem>
            <OrcamentoCardItem>
              <span>Pagamento:</span> 
              <SelectPayment
                $load={fetchOrcamentos}
                $orcamento_id={orcamento.id}
                $status_pagamento={orcamento.status_pagamento} 
              />
            </OrcamentoCardItem>
            <OrcamentoCardItem>
              <span>Status:</span>
              <SelectStatus 
                $load={fetchOrcamentos}
                $orcamento_id={orcamento.id}
                $status_viagem={orcamento.status_viagem}
                $data_inicio={orcamento.data_inicio}
                $data_fim={orcamento.data_fim}
              />
            </OrcamentoCardItem>
            <ButtonContainer>
              <div className="mobile-buttons">
                <div style={{ display: 'flex', justifyContent: 'space-around', gap: '6px', margin: "10px" }}>
                  <ViewMoreButton onClick={() => handleViewMoreClick(orcamento)}>Ver Mais</ViewMoreButton>
                  <EditButton onClick={() => handleEdit(orcamento.id)}>Editar</EditButton>
                  <CopyButton onClick={() => handleCopy(orcamento.id)}>Copiar</CopyButton>
                </div>
                <div style={{ display: 'flex', justifyContent: 'space-around', gap: '6px', margin: "10px" }}>
                  <PrintButton data={{ ...orcamento }} />
                  <DownloadButton data={{ ...orcamento }} />
                </div>
              </div>
            </ButtonContainer>
          </OrcamentoCard>
        ))}
      </CardWrapper>

      {showOrcamentoDetails && (
        <OrcamentoDetailsModal
          $load={fetchOrcamentos}
          orcamento={showOrcamentoDetails}
          onClose={() => setShowOrcamentoDetails(null)}
        />
      )}

      {orcamentoEditado && (
        <ModalWrapper>
          <ModalContainer>
            <CloseButton onClick={() => setOrcamentoEditado(null)}>×</CloseButton>
            <OrcamentoForm
              modo="editar"
              id={orcamentoEditado}
              onSuccess={() => {
                fetchOrcamentos();
                setOrcamentoEditado(null);
              }}
            />
          </ModalContainer>
        </ModalWrapper>
      )}
      {orcamentoCopiado && (
          <ModalWrapper>
            <ModalContainer>
              <CloseButton onClick={() => setOrcamentoCopiado(null)}>×</CloseButton>

              <OrcamentoForm
                modo="copiar"
                id={orcamentoCopiado}
                onSuccess={() => {
                  fetchOrcamentos();
                  setOrcamentoCopiado(null);
                }}
              />

            </ModalContainer>
          </ModalWrapper>
        )}
      {showCreateForm && (
        <ModalWrapper>
          <ModalContainer>
            <CloseButton onClick={() => setShowCreateForm(false)}>×</CloseButton>
            <OrcamentoForm
              onSuccess={() => {
                setShowCreateForm(false);
                fetchOrcamentos();
              }}
            />
          </ModalContainer>
        </ModalWrapper>
      )}


    </div>
  );
};

export default OrcamentoList;